var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "modal-card-body" }, [
      _c("div", { staticClass: "field" }, [
        _c(
          "label",
          {
            staticClass: "label",
            class: { "has-text-danger": _vm.errors.has("nombre", "serie") },
          },
          [_vm._v("Nombre del evento")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.nombre,
                expression: "nombre",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required:true}",
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.errors.has("nombre", "serie") },
            attrs: {
              name: "nombre",
              placeholder: "Requerido",
              "data-vv-scope": "serie",
            },
            domProps: { value: _vm.nombre },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.nombre = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm.errors.has("nombre", "serie")
          ? _c("span", { staticClass: "help is-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("nombre", "serie"))),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c(
            "b-checkbox",
            {
              attrs: { "native-value": true },
              model: {
                value: _vm.habilitarRestringirAreas,
                callback: function ($$v) {
                  _vm.habilitarRestringirAreas = $$v
                },
                expression: "habilitarRestringirAreas",
              },
            },
            [_vm._v("Habilitar restringir por areas")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.habilitarRestringirAreas
        ? _c("div", [
            _c("h3", { staticClass: "title is-6" }, [
              _vm._v("Seleccione las areas que podran correr la acción"),
            ]),
            _vm._v(" "),
            _vm.areasSeleccionadas.length == 0
              ? _c("p", { staticClass: "subtitle is-7" }, [
                  _c("i", { staticClass: "fas fa-info-circle fa-lg fa-fw" }),
                  _vm._v(
                    " No ha seleccionado ningun area en particular. Por lo tanto, todas las areas e individuos con privilegios pueden ejecutar el evento"
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.fetchedAreas
              ? _c(
                  "div",
                  { staticClass: "notification" },
                  _vm._l(_vm.areasDisponibles, function (area) {
                    return _c(
                      "b-checkbox",
                      {
                        key: area.id,
                        attrs: { "native-value": area.id },
                        model: {
                          value: _vm.areasSeleccionadas,
                          callback: function ($$v) {
                            _vm.areasSeleccionadas = $$v
                          },
                          expression: "areasSeleccionadas",
                        },
                      },
                      [
                        _vm._v(
                          "\r\n              " +
                            _vm._s(area.nombre) +
                            "\r\n            "
                        ),
                      ]
                    )
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.fetchingAreas && !_vm.fetchedAreas
              ? _c("div", [_vm._m(2)])
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-card-foot is-justify-content-flex-end" }, [
      _c(
        "button",
        {
          staticClass: "button is-dark is-outlined",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [_vm._v("Cancelar")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button is-primary",
          attrs: { type: "button" },
          on: { click: _vm.submit },
        },
        [_vm._v("Editar")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title is-800" }, [
        _vm._v("Editar evento"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [
        _vm._v("Reestringir ejecución por area"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("i", { staticClass: "fas fa-sync fa-spin" }),
      _vm._v(" Cargando areas..."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }